<template>
  <div>
    <wc-page-title title='Snow Project Report'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='year + " Snow Project Report"'
            titleIcon='mdi-snowflake'
            :loading='isLoading'
            showDownloadCSV
            @downloadCSV='downloadCSV'
          >
            <template v-slot:middle_column>
              <v-select
                style='width: 100px;'
                :items='yearOptions'
                label='Year'
                dense
                hide-details
                v-model='year'
                @change='changeYear'
              ></v-select>
            </template>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Date Sold</th>
                    <th>Project Names</th>
                    <th>Address</th>
                    <th>Customer</th>
                    <th class='text-center'>Invoice Double Checked</th>
                    <th class='text-center'>Routed</th>
                    <th class='text-center'>Picture Added</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='row in rows' :key='row.id'>
                    <td>{{ row.date_sold | shortDate }}</td>
                    <td>
                      <a :href='projectDetailUrl(row.project_id)' target='_blank' rel='noopener'>
                        {{ row.project_name }}
                      </a>
                    </td>
                    <td>{{ row.address }}</td>
                    <td>{{ row.customer }}</td>
                    <td class='text-center'>
                      <div class='d-flex justify-center'>
                        <v-checkbox
                          dense hide-details
                          v-model='row.invoice_double_checked'
                          @change='updateRow(row, "invoice_double_checked")'
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class='text-center'>
                      <div class='d-flex justify-center'>
                        <v-checkbox
                          dense hide-details
                          v-model='row.routed'
                          @change='updateRow(row, "routed")'
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class='text-center'>
                      <div class='d-flex justify-center'>
                        <v-checkbox
                          dense hide-details
                          v-model='row.picture_added'
                          @change='updateRow(row, "picture_added")'
                        ></v-checkbox>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class='text-center' style='padding-top: 25px; padding-bottom: 25px;'>
              <v-pagination v-model='page' :length='paginatorLength' @input='changePage'></v-pagination>
            </div>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model='snackbar' :color='snackbarColor' :timeout='3000' right>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import stagingAPI from '@/api/staging';
import { getSnowDate } from '@/modules/staging/functions/date';

export default {
  name: 'snow-project-report',
  data: () => ({
    isLoading: false,
    year: getSnowDate(),
    rows: [],
    count: 0,
    page: 1,
    numberPerPage: 50,
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success'
  }),
  computed: {
    paginatorLength () {
      return Math.max(1, Math.ceil(this.count / this.numberPerPage));
    },
    yearOptions () {
      const currentYear = getSnowDate();
      const options = [];
      for (let y = currentYear + 1; y >= currentYear - 5; y--) {
        options.push(y);
      }
      return options;
    }
  },
  mounted () {
    this.getData();
  },
  methods: {
    async getData () {
      this.isLoading = true;
      const data = await stagingAPI.getSnowProjectReport(this.year, this.page, this.numberPerPage);
      this.rows = data ? data.results : [];
      this.count = data ? data.count : 0;
      this.isLoading = false;
    },
    changeYear () {
      this.page = 1;
      this.getData();
    },
    changePage () {
      this.getData();
    },
    projectDetailUrl (projectId) {
      return `${window.location.origin}/#/snow/details/${projectId}/overview`;
    },
    async updateRow (row, field) {
      const previousValue = !row[field];
      const updated = await stagingAPI.updateSnowProjectReport(row.id, { [field]: row[field] });
      if (!updated) {
        row[field] = previousValue;
        this.snackbarText = 'Failed to update, please try again';
        this.snackbarColor = 'error';
        this.snackbar = true;
        return;
      }
      this.snackbarText = 'Updated successfully';
      this.snackbarColor = 'success';
      this.snackbar = true;
    },
    async downloadCSV () {
      const blob = await stagingAPI.downloadSnowProjectReportCSV(this.year);
      if (!blob) {
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `snow_project_report_${this.year}.csv`;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
</script>
